<template>
  <div class="displayField">
    <span>
      {{ label }}
    </span>
    <input
      type="text"
      readonly
      disabled
      v-model="value"
      :placeholder="placeholder"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DisplayField extends Vue {
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() placeholder!: string;
}
</script>

<style scoped>
input {
  box-sizing: border-box;
  padding: 5px;
  width: 100%;
  border: none;
  background-color: white;
  color: black;
  font-size: 95%;
}

.displayField {
  display: grid;
  grid-template-columns: 20ex auto;
  border: 1px solid lightgray;
  margin: 2px 0;
}

.displayField span {
  padding: 4px;
  padding-left: 5px;
  color: gray;
  font-size: 90%;
  font-style: italic;
}
</style>
